export const CUSTOM_COMPONENT_LOAD_PROJECT_DETAIL_CUSTOM_COMPONENT_BEGIN =
  'CUSTOM_COMPONENT_LOAD_PROJECT_DETAIL_CUSTOM_COMPONENT_BEGIN';
export const CUSTOM_COMPONENT_LOAD_PROJECT_DETAIL_CUSTOM_COMPONENT_SUCCESS =
  'CUSTOM_COMPONENT_LOAD_PROJECT_DETAIL_CUSTOM_COMPONENT_SUCCESS';
export const CUSTOM_COMPONENT_LOAD_PROJECT_DETAIL_CUSTOM_COMPONENT_FAILURE =
  'CUSTOM_COMPONENT_LOAD_PROJECT_DETAIL_CUSTOM_COMPONENT_FAILURE';
export const CUSTOM_COMPONENT_LOAD_PROJECT_DETAIL_CUSTOM_COMPONENT_DISMISS_ERROR =
  'CUSTOM_COMPONENT_LOAD_PROJECT_DETAIL_CUSTOM_COMPONENT_DISMISS_ERROR';
export const CUSTOM_COMPONENT_ADD_CUSTOM_COMPONENT_CONFIG_BEGIN =
  'CUSTOM_COMPONENT_ADD_CUSTOM_COMPONENT_CONFIG_BEGIN';
export const CUSTOM_COMPONENT_ADD_CUSTOM_COMPONENT_CONFIG_SUCCESS =
  'CUSTOM_COMPONENT_ADD_CUSTOM_COMPONENT_CONFIG_SUCCESS';
export const CUSTOM_COMPONENT_ADD_CUSTOM_COMPONENT_CONFIG_FAILURE =
  'CUSTOM_COMPONENT_ADD_CUSTOM_COMPONENT_CONFIG_FAILURE';
export const CUSTOM_COMPONENT_ADD_CUSTOM_COMPONENT_CONFIG_DISMISS_ERROR =
  'CUSTOM_COMPONENT_ADD_CUSTOM_COMPONENT_CONFIG_DISMISS_ERROR';
export const CUSTOM_COMPONENT_LOAD_CUSTOM_COMPONENT_CONFIGS_BEGIN =
  'CUSTOM_COMPONENT_LOAD_CUSTOM_COMPONENT_CONFIGS_BEGIN';
export const CUSTOM_COMPONENT_LOAD_CUSTOM_COMPONENT_CONFIGS_SUCCESS =
  'CUSTOM_COMPONENT_LOAD_CUSTOM_COMPONENT_CONFIGS_SUCCESS';
export const CUSTOM_COMPONENT_LOAD_CUSTOM_COMPONENT_CONFIGS_FAILURE =
  'CUSTOM_COMPONENT_LOAD_CUSTOM_COMPONENT_CONFIGS_FAILURE';
export const CUSTOM_COMPONENT_LOAD_CUSTOM_COMPONENT_CONFIGS_DISMISS_ERROR =
  'CUSTOM_COMPONENT_LOAD_CUSTOM_COMPONENT_CONFIGS_DISMISS_ERROR';
export const CUSTOM_COMPONENT_DELETE_CUSTOM_COMPONENT_CONFIG_BEGIN =
  'CUSTOM_COMPONENT_DELETE_CUSTOM_COMPONENT_CONFIG_BEGIN';
export const CUSTOM_COMPONENT_DELETE_CUSTOM_COMPONENT_CONFIG_SUCCESS =
  'CUSTOM_COMPONENT_DELETE_CUSTOM_COMPONENT_CONFIG_SUCCESS';
export const CUSTOM_COMPONENT_DELETE_CUSTOM_COMPONENT_CONFIG_FAILURE =
  'CUSTOM_COMPONENT_DELETE_CUSTOM_COMPONENT_CONFIG_FAILURE';
export const CUSTOM_COMPONENT_DELETE_CUSTOM_COMPONENT_CONFIG_DISMISS_ERROR =
  'CUSTOM_COMPONENT_DELETE_CUSTOM_COMPONENT_CONFIG_DISMISS_ERROR';
export const CUSTOM_COMPONENT_UPDATE_CUSTOM_COMPONENT_CONFIG_BEGIN =
  'CUSTOM_COMPONENT_UPDATE_CUSTOM_COMPONENT_CONFIG_BEGIN';
export const CUSTOM_COMPONENT_UPDATE_CUSTOM_COMPONENT_CONFIG_SUCCESS =
  'CUSTOM_COMPONENT_UPDATE_CUSTOM_COMPONENT_CONFIG_SUCCESS';
export const CUSTOM_COMPONENT_UPDATE_CUSTOM_COMPONENT_CONFIG_FAILURE =
  'CUSTOM_COMPONENT_UPDATE_CUSTOM_COMPONENT_CONFIG_FAILURE';
export const CUSTOM_COMPONENT_UPDATE_CUSTOM_COMPONENT_CONFIG_DISMISS_ERROR =
  'CUSTOM_COMPONENT_UPDATE_CUSTOM_COMPONENT_CONFIG_DISMISS_ERROR';
export const CUSTOM_COMPONENT_ADD_CUSTOM_COMPONENT_CSS_CDN_BEGIN =
  'CUSTOM_COMPONENT_ADD_CUSTOM_COMPONENT_CSS_CDN_BEGIN';
export const CUSTOM_COMPONENT_ADD_CUSTOM_COMPONENT_CSS_CDN_SUCCESS =
  'CUSTOM_COMPONENT_ADD_CUSTOM_COMPONENT_CSS_CDN_SUCCESS';
export const CUSTOM_COMPONENT_ADD_CUSTOM_COMPONENT_CSS_CDN_FAILURE =
  'CUSTOM_COMPONENT_ADD_CUSTOM_COMPONENT_CSS_CDN_FAILURE';
export const CUSTOM_COMPONENT_ADD_CUSTOM_COMPONENT_CSS_CDN_DISMISS_ERROR =
  'CUSTOM_COMPONENT_ADD_CUSTOM_COMPONENT_CSS_CDN_DISMISS_ERROR';
export const CUSTOM_COMPONENT_DELETE_CUSTOM_COMPONENT_CSS_CDN_BEGIN =
  'CUSTOM_COMPONENT_DELETE_CUSTOM_COMPONENT_CSS_CDN_BEGIN';
export const CUSTOM_COMPONENT_DELETE_CUSTOM_COMPONENT_CSS_CDN_SUCCESS =
  'CUSTOM_COMPONENT_DELETE_CUSTOM_COMPONENT_CSS_CDN_SUCCESS';
export const CUSTOM_COMPONENT_DELETE_CUSTOM_COMPONENT_CSS_CDN_FAILURE =
  'CUSTOM_COMPONENT_DELETE_CUSTOM_COMPONENT_CSS_CDN_FAILURE';
export const CUSTOM_COMPONENT_DELETE_CUSTOM_COMPONENT_CSS_CDN_DISMISS_ERROR =
  'CUSTOM_COMPONENT_DELETE_CUSTOM_COMPONENT_CSS_CDN_DISMISS_ERROR';
export const CUSTOM_COMPONENT_UPDATE_CUSTOM_COMPONENT_CSS_CDN_BEGIN =
  'CUSTOM_COMPONENT_UPDATE_CUSTOM_COMPONENT_CSS_CDN_BEGIN';
export const CUSTOM_COMPONENT_UPDATE_CUSTOM_COMPONENT_CSS_CDN_SUCCESS =
  'CUSTOM_COMPONENT_UPDATE_CUSTOM_COMPONENT_CSS_CDN_SUCCESS';
export const CUSTOM_COMPONENT_UPDATE_CUSTOM_COMPONENT_CSS_CDN_FAILURE =
  'CUSTOM_COMPONENT_UPDATE_CUSTOM_COMPONENT_CSS_CDN_FAILURE';
export const CUSTOM_COMPONENT_UPDATE_CUSTOM_COMPONENT_CSS_CDN_DISMISS_ERROR =
  'CUSTOM_COMPONENT_UPDATE_CUSTOM_COMPONENT_CSS_CDN_DISMISS_ERROR';
export const CUSTOM_COMPONENT_ADD_CUSTOM_COMPONENT_JS_CDN_BEGIN =
  'CUSTOM_COMPONENT_ADD_CUSTOM_COMPONENT_JS_CDN_BEGIN';
export const CUSTOM_COMPONENT_ADD_CUSTOM_COMPONENT_JS_CDN_SUCCESS =
  'CUSTOM_COMPONENT_ADD_CUSTOM_COMPONENT_JS_CDN_SUCCESS';
export const CUSTOM_COMPONENT_ADD_CUSTOM_COMPONENT_JS_CDN_FAILURE =
  'CUSTOM_COMPONENT_ADD_CUSTOM_COMPONENT_JS_CDN_FAILURE';
export const CUSTOM_COMPONENT_ADD_CUSTOM_COMPONENT_JS_CDN_DISMISS_ERROR =
  'CUSTOM_COMPONENT_ADD_CUSTOM_COMPONENT_JS_CDN_DISMISS_ERROR';
export const CUSTOM_COMPONENT_DELETE_CUSTOM_COMPONENT_JS_CDN_BEGIN =
  'CUSTOM_COMPONENT_DELETE_CUSTOM_COMPONENT_JS_CDN_BEGIN';
export const CUSTOM_COMPONENT_DELETE_CUSTOM_COMPONENT_JS_CDN_SUCCESS =
  'CUSTOM_COMPONENT_DELETE_CUSTOM_COMPONENT_JS_CDN_SUCCESS';
export const CUSTOM_COMPONENT_DELETE_CUSTOM_COMPONENT_JS_CDN_FAILURE =
  'CUSTOM_COMPONENT_DELETE_CUSTOM_COMPONENT_JS_CDN_FAILURE';
export const CUSTOM_COMPONENT_DELETE_CUSTOM_COMPONENT_JS_CDN_DISMISS_ERROR =
  'CUSTOM_COMPONENT_DELETE_CUSTOM_COMPONENT_JS_CDN_DISMISS_ERROR';
export const CUSTOM_COMPONENT_UPDATE_CUSTOM_COMPONENT_JS_CDN_BEGIN =
  'CUSTOM_COMPONENT_UPDATE_CUSTOM_COMPONENT_JS_CDN_BEGIN';
export const CUSTOM_COMPONENT_UPDATE_CUSTOM_COMPONENT_JS_CDN_SUCCESS =
  'CUSTOM_COMPONENT_UPDATE_CUSTOM_COMPONENT_JS_CDN_SUCCESS';
export const CUSTOM_COMPONENT_UPDATE_CUSTOM_COMPONENT_JS_CDN_FAILURE =
  'CUSTOM_COMPONENT_UPDATE_CUSTOM_COMPONENT_JS_CDN_FAILURE';
export const CUSTOM_COMPONENT_UPDATE_CUSTOM_COMPONENT_JS_CDN_DISMISS_ERROR =
  'CUSTOM_COMPONENT_UPDATE_CUSTOM_COMPONENT_JS_CDN_DISMISS_ERROR';
export const CUSTOM_COMPONENT_ADD_CUSTOM_DATA_MAPPING_BEGIN =
  'CUSTOM_COMPONENT_ADD_CUSTOM_DATA_MAPPING_BEGIN';
export const CUSTOM_COMPONENT_ADD_CUSTOM_DATA_MAPPING_SUCCESS =
  'CUSTOM_COMPONENT_ADD_CUSTOM_DATA_MAPPING_SUCCESS';
export const CUSTOM_COMPONENT_ADD_CUSTOM_DATA_MAPPING_FAILURE =
  'CUSTOM_COMPONENT_ADD_CUSTOM_DATA_MAPPING_FAILURE';
export const CUSTOM_COMPONENT_ADD_CUSTOM_DATA_MAPPING_DISMISS_ERROR =
  'CUSTOM_COMPONENT_ADD_CUSTOM_DATA_MAPPING_DISMISS_ERROR';
export const CUSTOM_COMPONENT_LOAD_CUSTOM_DATA_MAPPING_BEGIN =
  'CUSTOM_COMPONENT_LOAD_CUSTOM_DATA_MAPPING_BEGIN';
export const CUSTOM_COMPONENT_LOAD_CUSTOM_DATA_MAPPING_SUCCESS =
  'CUSTOM_COMPONENT_LOAD_CUSTOM_DATA_MAPPING_SUCCESS';
export const CUSTOM_COMPONENT_LOAD_CUSTOM_DATA_MAPPING_FAILURE =
  'CUSTOM_COMPONENT_LOAD_CUSTOM_DATA_MAPPING_FAILURE';
export const CUSTOM_COMPONENT_LOAD_CUSTOM_DATA_MAPPING_DISMISS_ERROR =
  'CUSTOM_COMPONENT_LOAD_CUSTOM_DATA_MAPPING_DISMISS_ERROR';
export const CUSTOM_COMPONENT_DELETE_CUSTOM_DATA_MAPPING_BEGIN =
  'CUSTOM_COMPONENT_DELETE_CUSTOM_DATA_MAPPING_BEGIN';
export const CUSTOM_COMPONENT_DELETE_CUSTOM_DATA_MAPPING_SUCCESS =
  'CUSTOM_COMPONENT_DELETE_CUSTOM_DATA_MAPPING_SUCCESS';
export const CUSTOM_COMPONENT_DELETE_CUSTOM_DATA_MAPPING_FAILURE =
  'CUSTOM_COMPONENT_DELETE_CUSTOM_DATA_MAPPING_FAILURE';
export const CUSTOM_COMPONENT_DELETE_CUSTOM_DATA_MAPPING_DISMISS_ERROR =
  'CUSTOM_COMPONENT_DELETE_CUSTOM_DATA_MAPPING_DISMISS_ERROR';
export const CUSTOM_COMPONENT_UPDATE_CUSTOM_DATA_MAPPING_BEGIN =
  'CUSTOM_COMPONENT_UPDATE_CUSTOM_DATA_MAPPING_BEGIN';
export const CUSTOM_COMPONENT_UPDATE_CUSTOM_DATA_MAPPING_SUCCESS =
  'CUSTOM_COMPONENT_UPDATE_CUSTOM_DATA_MAPPING_SUCCESS';
export const CUSTOM_COMPONENT_UPDATE_CUSTOM_DATA_MAPPING_FAILURE =
  'CUSTOM_COMPONENT_UPDATE_CUSTOM_DATA_MAPPING_FAILURE';
export const CUSTOM_COMPONENT_UPDATE_CUSTOM_DATA_MAPPING_DISMISS_ERROR =
  'CUSTOM_COMPONENT_UPDATE_CUSTOM_DATA_MAPPING_DISMISS_ERROR';
export const CUSTOM_COMPONENT_LOAD_CUSTOM_COMPONENT_CONFIG_BEGIN =
  'CUSTOM_COMPONENT_LOAD_CUSTOM_COMPONENT_CONFIG_BEGIN';
export const CUSTOM_COMPONENT_LOAD_CUSTOM_COMPONENT_CONFIG_SUCCESS =
  'CUSTOM_COMPONENT_LOAD_CUSTOM_COMPONENT_CONFIG_SUCCESS';
export const CUSTOM_COMPONENT_LOAD_CUSTOM_COMPONENT_CONFIG_FAILURE =
  'CUSTOM_COMPONENT_LOAD_CUSTOM_COMPONENT_CONFIG_FAILURE';
export const CUSTOM_COMPONENT_LOAD_CUSTOM_COMPONENT_CONFIG_DISMISS_ERROR =
  'CUSTOM_COMPONENT_LOAD_CUSTOM_COMPONENT_CONFIG_DISMISS_ERROR';
export const CUSTOM_COMPONENT_CLONE_CUSTOM_COMPONENT_BEGIN =
  'CUSTOM_COMPONENT_CLONE_CUSTOM_COMPONENT_BEGIN';
export const CUSTOM_COMPONENT_CLONE_CUSTOM_COMPONENT_SUCCESS =
  'CUSTOM_COMPONENT_CLONE_CUSTOM_COMPONENT_SUCCESS';
export const CUSTOM_COMPONENT_CLONE_CUSTOM_COMPONENT_FAILURE =
  'CUSTOM_COMPONENT_CLONE_CUSTOM_COMPONENT_FAILURE';
export const CUSTOM_COMPONENT_CLONE_CUSTOM_COMPONENT_DISMISS_ERROR =
  'CUSTOM_COMPONENT_CLONE_CUSTOM_COMPONENT_DISMISS_ERROR';
export const CUSTOM_COMPONENT_GET_PERMISSION_FLAGS_BEGIN =
  'CUSTOM_COMPONENT_GET_PERMISSION_FLAGS_BEGIN';
export const CUSTOM_COMPONENT_GET_PERMISSION_FLAGS_SUCCESS =
  'CUSTOM_COMPONENT_GET_PERMISSION_FLAGS_SUCCESS';
export const CUSTOM_COMPONENT_GET_PERMISSION_FLAGS_FAILURE =
  'CUSTOM_COMPONENT_GET_PERMISSION_FLAGS_FAILURE';
export const CUSTOM_COMPONENT_GET_PERMISSION_FLAGS_DISMISS_ERROR =
  'CUSTOM_COMPONENT_GET_PERMISSION_FLAGS_DISMISS_ERROR';
export const CUSTOM_COMPONENT_CLONE_CUSTOM_DATA_MAPPING_BEGIN =
  'CUSTOM_COMPONENT_CLONE_CUSTOM_DATA_MAPPING_BEGIN';
export const CUSTOM_COMPONENT_CLONE_CUSTOM_DATA_MAPPING_SUCCESS =
  'CUSTOM_COMPONENT_CLONE_CUSTOM_DATA_MAPPING_SUCCESS';
export const CUSTOM_COMPONENT_CLONE_CUSTOM_DATA_MAPPING_FAILURE =
  'CUSTOM_COMPONENT_CLONE_CUSTOM_DATA_MAPPING_FAILURE';
export const CUSTOM_COMPONENT_CLONE_CUSTOM_DATA_MAPPING_DISMISS_ERROR =
  'CUSTOM_COMPONENT_CLONE_CUSTOM_DATA_MAPPING_DISMISS_ERROR';
export const CUSTOM_COMPONENT_DELETE_CUSTOM_FUNCTION_BEGIN =
  'CUSTOM_COMPONENT_DELETE_CUSTOM_FUNCTION_BEGIN';
export const CUSTOM_COMPONENT_DELETE_CUSTOM_FUNCTION_SUCCESS =
  'CUSTOM_COMPONENT_DELETE_CUSTOM_FUNCTION_SUCCESS';
export const CUSTOM_COMPONENT_DELETE_CUSTOM_FUNCTION_FAILURE =
  'CUSTOM_COMPONENT_DELETE_CUSTOM_FUNCTION_FAILURE';
export const CUSTOM_COMPONENT_DELETE_CUSTOM_FUNCTION_DISMISS_ERROR =
  'CUSTOM_COMPONENT_DELETE_CUSTOM_FUNCTION_DISMISS_ERROR';
export const CUSTOM_COMPONENT_LOAD_CUSTOM_FUNCTION_CONFIG =
  'CUSTOM_COMPONENT_LOAD_CUSTOM_FUNCTION_CONFIG';
export const CUSTOM_COMPONENT_LOAD_CUSTOM_FUNCTION_CONFIG_BEGIN =
  'CUSTOM_COMPONENT_LOAD_CUSTOM_FUNCTION_CONFIG_BEGIN';
export const CUSTOM_COMPONENT_LOAD_CUSTOM_FUNCTION_CONFIG_SUCCESS =
  'CUSTOM_COMPONENT_LOAD_CUSTOM_FUNCTION_CONFIG_SUCCESS';
export const CUSTOM_COMPONENT_LOAD_CUSTOM_FUNCTION_CONFIG_FAILURE =
  'CUSTOM_COMPONENT_LOAD_CUSTOM_FUNCTION_CONFIG_FAILURE';
export const CUSTOM_COMPONENT_LOAD_CUSTOM_FUNCTION_CONFIG_DISMISS_ERROR =
  'CUSTOM_COMPONENT_LOAD_CUSTOM_FUNCTION_CONFIG_DISMISS_ERROR';
export const CUSTOM_COMPONENT_LOAD_CUSTOM_FUNCTION_DETAIL_BEGIN =
  'CUSTOM_COMPONENT_LOAD_CUSTOM_FUNCTION_DETAIL_BEGIN';
export const CUSTOM_COMPONENT_LOAD_CUSTOM_FUNCTION_DETAIL_SUCCESS =
  'CUSTOM_COMPONENT_LOAD_CUSTOM_FUNCTION_DETAIL_SUCCESS';
export const CUSTOM_COMPONENT_LOAD_CUSTOM_FUNCTION_DETAIL_FAILURE =
  'CUSTOM_COMPONENT_LOAD_CUSTOM_FUNCTION_DETAIL_FAILURE';
export const CUSTOM_COMPONENT_LOAD_CUSTOM_FUNCTION_DETAIL_DISMISS_ERROR =
  'CUSTOM_COMPONENT_LOAD_CUSTOM_FUNCTION_DETAIL_DISMISS_ERROR';
export const CUSTOM_COMPONENT_UPDATE_CUSTOM_FUNCTION_BEGIN =
  'CUSTOM_COMPONENT_UPDATE_CUSTOM_FUNCTION_BEGIN';
export const CUSTOM_COMPONENT_UPDATE_CUSTOM_FUNCTION_SUCCESS =
  'CUSTOM_COMPONENT_UPDATE_CUSTOM_FUNCTION_SUCCESS';
export const CUSTOM_COMPONENT_UPDATE_CUSTOM_FUNCTION_FAILURE =
  'CUSTOM_COMPONENT_UPDATE_CUSTOM_FUNCTION_FAILURE';
export const CUSTOM_COMPONENT_UPDATE_CUSTOM_FUNCTION_DISMISS_ERROR =
  'CUSTOM_COMPONENT_UPDATE_CUSTOM_FUNCTION_DISMISS_ERROR';
export const CUSTOM_COMPONENT_ADD_CUSTOM_FUNCTION_BEGIN =
  'CUSTOM_COMPONENT_ADD_CUSTOM_FUNCTION_BEGIN';
export const CUSTOM_COMPONENT_ADD_CUSTOM_FUNCTION_SUCCESS =
  'CUSTOM_COMPONENT_ADD_CUSTOM_FUNCTION_SUCCESS';
export const CUSTOM_COMPONENT_ADD_CUSTOM_FUNCTION_FAILURE =
  'CUSTOM_COMPONENT_ADD_CUSTOM_FUNCTION_FAILURE';
export const CUSTOM_COMPONENT_ADD_CUSTOM_FUNCTION_DISMISS_ERROR =
  'CUSTOM_COMPONENT_ADD_CUSTOM_FUNCTION_DISMISS_ERROR';
export const CUSTOM_COMPONENT_CUSTOM_FUNCTION_EXECUTION_BEGIN =
  'CUSTOM_COMPONENT_CUSTOM_FUNCTION_EXECUTION_BEGIN';
export const CUSTOM_COMPONENT_CUSTOM_FUNCTION_EXECUTION_SUCCESS =
  'CUSTOM_COMPONENT_CUSTOM_FUNCTION_EXECUTION_SUCCESS';
export const CUSTOM_COMPONENT_CUSTOM_FUNCTION_EXECUTION_FAILURE =
  'CUSTOM_COMPONENT_CUSTOM_FUNCTION_EXECUTION_FAILURE';
export const CUSTOM_COMPONENT_CUSTOM_FUNCTION_EXECUTION_DISMISS_ERROR =
  'CUSTOM_COMPONENT_CUSTOM_FUNCTION_EXECUTION_DISMISS_ERROR';
export const CUSTOM_COMPONENT_CUSTOM_FUNCTION_LOGS_BEGIN =
  'CUSTOM_COMPONENT_CUSTOM_FUNCTION_LOGS_BEGIN';
export const CUSTOM_COMPONENT_CUSTOM_FUNCTION_LOGS_SUCCESS =
  'CUSTOM_COMPONENT_CUSTOM_FUNCTION_LOGS_SUCCESS';
export const CUSTOM_COMPONENT_CUSTOM_FUNCTION_LOGS_FAILURE =
  'CUSTOM_COMPONENT_CUSTOM_FUNCTION_LOGS_FAILURE';
export const CUSTOM_COMPONENT_CUSTOM_FUNCTION_LOGS_DISMISS_ERROR =
  'CUSTOM_COMPONENT_CUSTOM_FUNCTION_LOGS_DISMISS_ERROR';
export const CUSTOM_COMPONENT_CLONE_CUSTOM_FUNCTION_BEGIN = 'CUSTOM_COMPONENT_CLONE_CUSTOM_FUNCTION_BEGIN';
export const CUSTOM_COMPONENT_CLONE_CUSTOM_FUNCTION_SUCCESS = 'CUSTOM_COMPONENT_CLONE_CUSTOM_FUNCTION_SUCCESS';
export const CUSTOM_COMPONENT_CLONE_CUSTOM_FUNCTION_FAILURE = 'CUSTOM_COMPONENT_CLONE_CUSTOM_FUNCTION_FAILURE';
export const CUSTOM_COMPONENT_CLONE_CUSTOM_FUNCTION_DISMISS_ERROR = 'CUSTOM_COMPONENT_CLONE_CUSTOM_FUNCTION_DISMISS_ERROR';
export const CUSTOM_COMPONENT_GENERATE_CUSTOM_COMPONENT_BEGIN = 'CUSTOM_COMPONENT_GENERATE_CUSTOM_COMPONENT_BEGIN';
export const CUSTOM_COMPONENT_GENERATE_CUSTOM_COMPONENT_SUCCESS = 'CUSTOM_COMPONENT_GENERATE_CUSTOM_COMPONENT_SUCCESS';
export const CUSTOM_COMPONENT_GENERATE_CUSTOM_COMPONENT_FAILURE = 'CUSTOM_COMPONENT_GENERATE_CUSTOM_COMPONENT_FAILURE';
export const CUSTOM_COMPONENT_GENERATE_CUSTOM_COMPONENT_DISMISS_ERROR = 'CUSTOM_COMPONENT_GENERATE_CUSTOM_COMPONENT_DISMISS_ERROR';
